type FilterInputProps = {
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  type?: string
  className?: string
}

const FilterInput = ({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  className = 'flex-1',
}: FilterInputProps) => {
  return (
    <div className={className}>
      <label className="form-control">
        <div className="label">
          <span className="label-text">{label}</span>
        </div>
        <input
          className="input input-bordered w-full"
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={e => onChange(e.target.value)}
        />
      </label>
    </div>
  )
}

export type { FilterInputProps }
export { FilterInput }
